export default "__VITE_ASSET__CdgpoUw2__"